export const light = {
    divCSS: "bg-white dark:text-black",
    buttonCSS: "bg-slate-700 text-white capitalize",
    lightButtonCSS: "capitalize",
    inputCSS: "bg-white",
    iconHex: "#2E3A59",
    tableHeaderCSS: "bg-gray-200 text-gray-600",
    text: "text-black",
    menu: "hover:bg-gray-200 bg-white dark:text-black",
    messageItem: "hover:bg-gray-100",
    // Semantic tokens for redesigned tenant pages
    pageBg: '#F2F2F7',
    cardBg: 'bg-white',
    cardTitle: 'text-gray-900',
    cardText: 'text-gray-700',
    cardSubtext: 'text-gray-500',
    cardMuted: 'text-gray-400',
    cardBorder: 'border-gray-100',
    cardHover: 'hover:bg-gray-50',
    skeleton: 'bg-gray-200',
    dropdownBg: 'bg-white',
    dropdownText: 'text-gray-700',
    dropdownHover: 'hover:bg-gray-50',
    dropdownBorder: 'ring-black/5',
    badgeMuted: 'bg-gray-100 text-gray-400',
};
export const dark = {
    divCSS: "bg-slate-800 text-white",
    buttonCSS: "border-white capitalize",
    lightButtonCSS: "capitalize",
    inputCSS: "bg-slate-800 text-white placeholder-white",
    iconHex: "#fff",
    tableHeaderCSS: "bg-slate-800 text-white",
    text: "text-white",
    menu: "hover:bg-slate-700 bg-slate-800 text-white",
    messageItem: "bg-slate-800 hover:bg-slate-600",
    // Semantic tokens for redesigned tenant pages
    pageBg: '#1e293b',
    cardBg: 'bg-slate-700',
    cardTitle: 'text-white',
    cardText: 'text-gray-200',
    cardSubtext: 'text-gray-400',
    cardMuted: 'text-gray-500',
    cardBorder: 'border-slate-600',
    cardHover: 'hover:bg-slate-600',
    skeleton: 'bg-slate-600',
    dropdownBg: 'bg-slate-700',
    dropdownText: 'text-gray-200',
    dropdownHover: 'hover:bg-slate-600',
    dropdownBorder: 'ring-white/10',
    badgeMuted: 'bg-slate-600 text-gray-400',
};
export const highContrast = {
    divCSS: "bg-yellow-300 text-black",
    buttonCSS: "bg-yellow-300 text-black capitalize border-2 border-black",
    lightButtonCSS: "bg-yellow-300 text-black capitalize border-2 border-black",
    inputCSS: "bg-white text-black placeholder-black border-2 border-black",
    iconHex: "#000000",
    tableHeaderCSS: "bg-black text-yellow-300",
    text: "text-black",
    menu: "hover:bg-yellow-400 bg-yellow-300 text-black",
    messageItem: "bg-yellow-300 hover:bg-yellow-400",
    // Semantic tokens for redesigned tenant pages
    pageBg: '#FFFFFF',
    cardBg: 'bg-white border-2 border-black',
    cardTitle: 'text-black',
    cardText: 'text-black',
    cardSubtext: 'text-black',
    cardMuted: 'text-gray-800',
    cardBorder: 'border-black',
    cardHover: 'hover:bg-yellow-100',
    skeleton: 'bg-gray-400',
    dropdownBg: 'bg-yellow-300',
    dropdownText: 'text-black',
    dropdownHover: 'hover:bg-yellow-400',
    dropdownBorder: 'ring-black',
    badgeMuted: 'bg-yellow-200 text-black',
};  